import { getFieldValue } from '@sitecore-jss/sitecore-jss-angular';

export const getRenderingValue =
  <T>(key: string, defaultValue: T) =>
  (state: any) => {
    return getFieldValue<T>(state.rendering, key, defaultValue);
  };
